import apiClient from './apiClient';
import { AgentRequestRequest } from '../structures/request/AgentRequestRequest';
import { AgentRequestResponse } from '../structures/response/AgentRequestResponse';
import {
  FileManaged,
  FileManagedSystemDocument,
} from '../structures/response/FileManaged';
import { AgentReportResponse } from '../structures/response/AgentReportResponse';
import { AgentProfileInfo } from '../structures/response/AgentProfileInfo';
import { RegisterCreateRequest } from '../structures/request/RegisterCreateRequest';

export const createRequest = (
  data: AgentRequestRequest
): Promise<AgentRequestResponse> =>
  apiClient.post('agent/agent/create-request', data).then((r) => r.data);

export const requestList = (): Promise<AgentRequestResponse[]> =>
  apiClient.get('agent/agent/request-list').then((r) => r.data);

export const getBorrowerReferralLink = () =>
  apiClient.get('referral/account/borrower-referral-link').then((r) => r.data);

export const agentFileUpload = (
  file: File,
  requestId: number | string
): Promise<FileManaged> => {
  const url = `agent/agent/request-upload-file?requestId=${requestId}`;
  const fd = new FormData();
  fd.append('file', file);
  fd.append('category', 'AGENT_REQUEST');
  return apiClient.post(url, fd).then((r) => r.data);
};

export const agentFileDelete = (id: number | string): Promise<void> =>
  apiClient.delete(`file/storage/delete?id=${id}`).then((r) => r.data);

export const feedbackSend = (message: string): Promise<void> => {
  const url = `api/feedback/send`;
  const params = {
    message,
  };
  return apiClient.post(url, params).then((r) => r.data);
};

export const getReportToSign = (
  agentRequestId: number | string
): Promise<AgentReportResponse> =>
  apiClient
    .get(`agent/agent/execute-report-view?id=${agentRequestId}`)
    .then((r) => r.data);

export const updateAgentProfile = (
  data: Pick<AgentProfileInfo, 'taxationSystem'>
): Promise<AgentReportResponse> =>
  apiClient.patch(`agent/agent/update-agent-profile`, data).then((r) => r.data);

export const createBankDetails = (
  data: RegisterCreateRequest
): Promise<unknown> =>
  apiClient.patch(`agent/agent/update-bank-details`, data).then((r) => r.data);

export const getAgentSystemDocuments = (): Promise<
  FileManagedSystemDocument[]
> =>
  apiClient
    .get(`agent/agent/agent-public-system-documents`)
    .then((r) => r.data);

export const confirmPledgeByTransport = (requestId: number | string) =>
  apiClient
    .patch(`agent/agent/confirm-by-transport?id=${requestId}`)
    .then((r) => r.data);
